// import external modules
import React from "react";
import { Route } from "react-router-dom";

// import internal(own) modules
import PublicLayout from "../publicLayout";

// Define a functional component called PublicLayoutRoute which takes in props including render function and rest of the props
const PublicLayoutRoute = ({ render, ...rest }) => {
  // Return a Route component from react-router-dom, spreading the rest of the props and defining a render prop function
  return (
    <Route
      {...rest} // Spread the rest of the props onto the Route component
      render={(matchProps) => (
        // Render a component PublicLayout and pass in the result of calling the render function with matchProps
        <PublicLayout>{render(matchProps)}</PublicLayout>
      )}
    />
  );
};

// Export the PublicLayoutRoute component as the default export
export default PublicLayoutRoute;
